import React, { useState, useEffect, useMemo } from 'react'
import { Stack } from '@mui/material'

import LoaderSitesMetrics from 'components/Cartography/LoaderMetrics'
import TableSkeleton from 'components/global/CUK/Skeletons/TableSkeleton'
import { useRegisterBreadcrumbAction } from 'components/AuthenticatedLayout/Header/components/BreadcrumbActions'

import TextFilter from '../../Topbar/Filters/TextFilter'
import ExportButton from '../../Topbar/ExportButton'
import useEquipments from '../use-equipments'
import { MainContent, TableContent } from '../../../PagesStyles'
import { useResetFilters } from '../../store'
import CardSites from './Card'
import Table from './Table'
import useExport from './use-export'
import useSsid from './use-ssid'
import useSort from '../use-sort'



const Ssids = ({ sites }) => {
  const [sitesSsid, setSites] = useState(null)
  const sortApi = useSort({defaultOrderBy : 'ssid_name'})
  const apiEquipments = useEquipments({sites})
  const accessPoints = useMemo(() => {
    return apiEquipments.equipments.access_points.filter(
      ({ site }) => sites.findIndex(({ id }) => id === site?.id) > -1,
    )
  }, [apiEquipments.equipments])
  const { ssids } = useSsid({equipments: accessPoints, sortApi})
  const createExport = useExport({ssids: ssids})
  useRegisterBreadcrumbAction(<ExportButton analyticsName="monitoring_ssids" onClick={async () => { await createExport() }} />)
  return (
    <>
      <Stack direction={'row'} justifyContent={'space-between'}>
        <Stack direction={'row'} gap={1}>
          <TextFilter />
        </Stack>
      </Stack>

      <MainContent mode={'expand'}>
        <TableContent mode={'expand'}>
          {
            apiEquipments.loading
              ? <TableContent mode={'expand'}><TableSkeleton /></TableContent>
              : <Table
                  ssidSelected={sitesSsid}
                  onRowClick={setSites}
                  equipments={accessPoints}
                  sortApi={sortApi}
                />
          }
        </TableContent>
        {Boolean(sitesSsid) && (
          <CardSites data={sitesSsid} onClose={() => setSites(null)} />
        )}
      </MainContent>
    </>
  )
}

const Loader = () => {
  const resetFilters = useResetFilters()
  useEffect(() => {
    resetFilters()
  }, [])
  return (
    <Stack gap={1} sx={{ flex: 1, minHeight: 0 }}>
      <LoaderSitesMetrics loader={<TableContent mode={'expand'}><TableSkeleton /></TableContent>}>
        {({ sites }) => (
          <Ssids sites={sites} />
        )}
      </LoaderSitesMetrics>
    </Stack>
  )
}

export default Loader
